import { render, staticRenderFns } from "./ButtonCountDown.vue?vue&type=template&id=245a979e&scoped=true&"
import script from "./ButtonCountDown.vue?vue&type=script&lang=js&"
export * from "./ButtonCountDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a979e",
  null
  
)

export default component.exports